import '../sticky-recap.scss';
import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import { Markup } from 'interweave';

interface IQuestionProps {
    index: number;
    title?: string;
    response?: string;
    showIndex?: boolean;
    focusStepToUpdate?: (stepKey) => void;
    children?: React.ReactNode;
}

const Question = (props: IQuestionProps) => {
    const { index, showIndex, title, response } = props || {};
    return (
        <div className='question' key={index}
            onClick={() => {
                props?.focusStepToUpdate(index);
            }}>
            {
                showIndex ?
                    <div className='question-index'>
                        {index + 1}
                    </div>
                    :
                    <div className='question-answered'>
                        <FontAwesomeIcon color='white' icon={faCheck} className="fa-check" />
                    </div>
            }
            <div className='recap-question-res'>
                <div className='recap-question-title'>
                    {title}
                </div>
                <div className='recap-question-response'>
                <Markup noWrap content= {response} /> 
                </div>
            </div>
            <div className="recap-question-action">
                <IconButton
                    className="btn-edit-sticky-recap"
                    aria-label="Modifier">
                    <CreateIcon />
                </IconButton>
            </div>
        </div>
    );
}
export default Question;